<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIASALIADOS' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioFrecuenciaAliado" name="nomFormularioFrecuenciaAliado">
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' | translate }}</label>
            <p-dropdown disableTab  id="idFrecuencia" name="nomFrecuencia" [options]="lisFrecuencias"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idFrecuenciaProducto"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFrecuenciaProducto.invalid">
              {{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS' | translate }}</label>
            <input type="text" pInputText id="idCuotas"
                   name="nomNumeroCuota"
                   autocomplete="off"
                   formControlName="numeroCuotas"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.numeroCuotas.invalid">
              {{ 'PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOFRECUENCIA.LBL_PLAZO' | translate }} ({{ 'PRODUCTOFRECUENCIA.LBL_DIAS' | translate }})</label>
            <input type="text" pInputText id="idPlazo"
                   name="nomPlazo"
                   autocomplete="off"
                   formControlName="plazo"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazo.invalid">
              {{ 'PRODUCTOFRECUENCIA.LBL_PLAZO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="proFrecuenciaDinero.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #proFrecuenciaDinero
                 [value]="lisProductosFrecuencias" selectionMode="single" dataKey="idProductoFrecuencia"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreFrecuenciaProducto}}</td>
              <td>{{row.numeroCuotas}}</td>
              <td>{{row.plazo}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="frecuencias-aliados">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
